import CheckCircleNew from "@icons/checkCircle_new_16.svg?react";
import ErrorCircleNew from "@icons/errorCircle_new_16.svg?react";

import { ApiUserSecretStatus } from "../models/api-users-models";

interface Props {
  secretStatus: ApiUserSecretStatus;
}

export const ApiUserSecretStatusIcon = ({ secretStatus }: Props) => {
  const renderIcon = () => {
    switch (secretStatus) {
      case ApiUserSecretStatus.Current:
        return (
          <div data-testid="active-user-status">
            <CheckCircleNew className="inline" /> {ApiUserSecretStatus.Current}
          </div>
        );

      case ApiUserSecretStatus.Expired:
        return (
          <div data-testid="invited-user-status">
            <ErrorCircleNew className="inline" /> {ApiUserSecretStatus.Expired}
          </div>
        );

      default:
        return null;
    }
  };

  return <>{renderIcon()}</>;
};
